import { postCardIssuerConstants, issuer_namespace } from "../constants/issuers.constants";

const initialState = {
  loading: false,
  success: false,
  request: null,
  response: null,
  error: null
};

export const postCardIssuers = (state = initialState, action) => {
  switch (action.type) {
    case postCardIssuerConstants[`GET_${issuer_namespace}_REQUEST`]:
      return {
        ...state,
        loading: true,
        request: action.request
      };
    case postCardIssuerConstants[`GET_${issuer_namespace}_SUCCESS`]:
      return {
        ...state,
        loading: false,
        success: true,
        response: action.response,
        error: null
      };
    case postCardIssuerConstants[`GET_${issuer_namespace}_FAILURE`]:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error
      };
    default:
      return state;
  }
};
